import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=1e7a1cdc&scoped=true"
import script from "./_slug.vue?vue&type=script&setup=true&lang=ts"
export * from "./_slug.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./_slug.vue?vue&type=style&index=0&id=1e7a1cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7a1cdc",
  null
  
)

export default component.exports